import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
